import React from 'react';
import styled from 'styled-components';
import { colors } from '~/styles';
import TableCell from './TableCell';
import TableRow from './TableRow';

const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  transition: opacity 250ms;
  opacity: ${({ fade }) => (fade ? 0.1 : 1)};
`;

const NoResultsCell = styled(TableCell)`
  flex: 1;
  color: ${colors.grey40};
`;

function TableBody({ children, showNoResults = true, ...props }) {
  return (
    <Body {...props}>
      {!children || children.length === 0
        ? showNoResults && (
            <TableRow>
              <NoResultsCell>No results</NoResultsCell>
            </TableRow>
          )
        : children}
    </Body>
  );
}

export default TableBody;
